import { UtilityTemplateServiceData } from 'services/GameHosting/DeploymentTemp/deploymentTemplateServiceType';

export const FETCH_UTILITY_DEPLOYMENT_TEMPLATE = 'FETCH_UTILITY_DEPLOYMENT_TEMPLATE';

export const FETCH_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING = 'FETCH_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const FETCH_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR = 'FETCH_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID = 'FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID';

export const FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID_IS_PENDING = 'FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID_IS_PENDING';

export const FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID_IS_ERROR = 'FETCH_UTILITY_DEPLOYMENT_TEMPLATE_BY_ID_IS_ERROR';

export const CREATE_UTILITY_DEPLOYMENT_TEMPLATE = 'CREATE_UTILITY_DEPLOYMENT_TEMPLATE';

export const CREATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING = 'CREATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const CREATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR = 'CREATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const UPDATE_UTILITY_DEPLOYMENT_TEMPLATE = 'UPDATE_UTILITY_DEPLOYMENT_TEMPLATE';

export const UPDATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING = 'UPDATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const UPDATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR = 'UPDATE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const DELETE_UTILITY_DEPLOYMENT_TEMPLATE = 'DELETE_UTILITY_DEPLOYMENT_TEMPLATE';

export const DELETE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING = 'DELETE_UTILITY_DEPLOYMENT_TEMPLATE_IS_PENDING';

export const DELETE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR = 'DELETE_UTILITY_DEPLOYMENT_TEMPLATE_IS_ERROR';

export const SORT = 'SORT_UTILITY_DEPLOYMENT_TEMPLATE';

export const CANCEL_EDITION = 'CANCEL_EDITION_UTILITY_DEPLOYMENT_TEMPLATE';

export const CLEAN_ERROR = 'CLEAN_ERROR_UTILITY_DEPLOYMENT_TEMPLATE';

export type UtilityTemplateReducer = {
  utilityDepTemp: UtilityTemplateServiceData[];
  fetchIsCompleted: boolean;
  fetchIsPending: boolean;
  fetchIsError: null | boolean;
  addIsError: null | boolean;
  createIsCompleted: boolean;
  createIsPending: boolean;
  createIsError: null | boolean;
  updateIsPending: boolean;
  updateIsCompleted: boolean;
  updateIsError: null | boolean;
};
